/**
 * Barre de rassurance — Daruma
 *
 * Rotation automatique des messages avec navigation manuelle :
 * points cliquables, balayage tactile sur mobile. La rotation se met en
 * pause au survol et repart après une action manuelle. Avec « animations
 * réduites » activé, pas de rotation automatique — la navigation manuelle
 * reste disponible.
 */

class RassuranceBar extends HTMLElement {
  connectedCallback() {
    this.messages = Array.from(this.querySelectorAll('.rassurance-bar__msg'));
    this.dots = Array.from(this.querySelectorAll('.rassurance-bar__dot'));

    if (this.messages.length < 2) {
      return;
    }

    this.index = 0;
    this.interval = parseInt(this.getAttribute('interval'), 10) || 3000;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this.activate(i);
        this.restart();
      });
    });

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());

    this.addEventListener(
      'touchstart',
      (event) => {
        this.touchStartX = event.changedTouches[0].clientX;
      },
      { passive: true }
    );

    this.addEventListener(
      'touchend',
      (event) => {
        const delta = event.changedTouches[0].clientX - this.touchStartX;

        if (Math.abs(delta) > 30) {
          const count = this.messages.length;
          const step = delta < 0 ? 1 : -1;
          this.activate((this.index + step + count) % count);
          this.restart();
        }
      },
      { passive: true }
    );

    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  activate(index) {
    this.messages[this.index]?.classList.remove('is-active');
    this.dots[this.index]?.classList.remove('is-active');
    this.dots[this.index]?.removeAttribute('aria-current');

    this.index = index;

    this.messages[this.index]?.classList.add('is-active');
    this.dots[this.index]?.classList.add('is-active');
    this.dots[this.index]?.setAttribute('aria-current', 'true');
  }

  start() {
    if (this.reducedMotion.matches) {
      return;
    }

    this.stop();
    this.timer = setInterval(() => {
      this.activate((this.index + 1) % this.messages.length);
    }, this.interval);
  }

  stop() {
    clearInterval(this.timer);
  }

  restart() {
    this.stop();
    this.start();
  }
}

if (!window.customElements.get('rassurance-bar')) {
  window.customElements.define('rassurance-bar', RassuranceBar);
}
